import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button, { ButtonWrapper } from 'blocks/Button';
import Row from 'blocks/Row';
import { Text } from 'blocks/Text';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import { ModalVeriKidesProps } from 'pages/signup/signup.interface';
import { useTranslation } from 'react-i18next';
import * as S from './modalNotificationParent.styles';

const ModalNotificationParent: ModalFC<ModalVeriKidesProps> = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <S.Wrapper>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px' }}>
            <CheckCircleIcon style={{ color: '#60C08E', fontSize: '60px' }} />
            <Text color="success" bold>
              Successful
            </Text>
          </div>
          <Row>
            <Text>{t('pages.signup.sections.verification.fields.NotifyTheParent')}</Text>
          </Row>
        </div>

        <ButtonWrapper justify="center">
          <Button onClick={onSubmit}> {t('pages.signup.sections.verification.fields.verifyKides.btn')}</Button>
        </ButtonWrapper>
      </S.Wrapper>
    </Modal>
  );
};

export default ModalNotificationParent;
